import type { Step } from 'react-joyride';

/** Tutorial steps shown to clients on their first visit (or on demand). */
export const CLIENT_TUTORIAL_STEPS: Step[] = [
  {
    target: '[data-tutorial="dashboard"]',
    content: 'Bun venit! Aceasta este consola ta principală. Aici poți monitoriza tichetele deschise, solicitările urgente și activitatea recentă.',
    placement: 'center',
  },
  {
    target: '[data-tutorial="nav-tickets"]',
    content: 'Accesează lista completă cu toate tichetele tale. Poți filtra după status, prioritate sau căuta după text.',
  },
  {
    target: '[data-tutorial="nav-new-ticket"]',
    content: 'Apasă aici pentru a deschide un tichet nou de suport.',
  },
  {
    target: '[data-tutorial="nav-profile"]',
    content: 'Aici poți vedea și actualiza profilul tău.',
  },
  {
    target: '[data-tutorial="notifications"]',
    content: 'Aici primești notificări în timp real despre actualizările tichetelor tale.',
  },
  {
    target: '[data-tutorial="theme-toggle"]',
    content: 'Poți schimba între modul luminos și cel întunecat.',
  },
];
